/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path, Line } from 'react-native-svg';

import { IconProps } from '../lib';

function HandsClapping(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M51.81106,121.9021a18,18,0,1,0-31.17691,18l37,64.08588a72,72,0,0,0,124.70766-72l-17-29.44487a18,18,0,0,0-31.17692,18"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
      <Path
        d="M106.988,145.47132l-38-65.81793a18,18,0,0,0-31.17692,18l38,65.81793"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
      <Path
        d="M150.16489,148.25593l-42-72.74614a18,18,0,0,0-31.17691,18"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
      <Path
        d="M99.04433,67.71252,88.70079,49.797a18,18,0,1,0-31.17691,18L59.867,71.85533"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
      <Path
        d="M188.03672,191.515a72.02623,72.02623,0,0,0,14.0179-89.38343l-17-29.44486a18,18,0,1,0-31.17691,18"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
      <Path
        d="M156.22161,94.74648l-28.3439-49.09309a18,18,0,0,0-31.17692,18"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
      <Line
        x1={176.84663}
        y1={11.27112}
        x2={172.70552}
        y2={26.72593}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
      <Line
        x1={207.06334}
        y1={25.3614}
        x2={197.88611}
        y2={38.46784}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
      <Line
        x1={230.6386}
        y1={48.93666}
        x2={217.53216}
        y2={58.11389}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
    </Svg>
  );
}

export default HandsClapping;
